import { render } from "./LeftPanel.vue?vue&type=template&id=550483c2&scoped=true"
import script from "./LeftPanel.vue?vue&type=script&lang=js"
export * from "./LeftPanel.vue?vue&type=script&lang=js"

import "./LeftPanel.vue?vue&type=style&index=0&id=550483c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550483c2"]])

export default __exports__